/* eslint-disable */
/*
 * Main lexicon customization component.
 * 
 * Almost all state for lexicon customization is maintained
 * here. Child components are almost exclusively presentational.
 */

import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { confirmAlert } from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'

import LexiconControls from './lexiconControls'
import LexentryRow from './lexentryRow'
import '../../stylesheets/lexicon.css'

import {
  addG2P,
  addLexentry,
  addLexicon,
  deleteLexicon,
  renameLexicon,
  deleteLexentry,
  getLexicons,
  getLexentries,
  updateField,
} from '../../modules/lexicon'

class Lexicon extends Component {
  constructor() {
    super()

    /* Maybe this should be stored in the DB? Maybe it should be an integer? */
    this.state = {
      showAdvanced: false,
      language: 'en-US',
    }
  }

  componentDidMount() {
    this.props.getLexicons()
  }

  /*
   * Methods that dispatch actions or modify state.
   */

  toggleShowAdvanced = () => {
    this.setState({showAdvanced: !this.state.showAdvanced})
  }

  addLexentry = (e) => {
    e.preventDefault()
    this.props.addLexentry(this.props.currentLexicon)
  }

  deleteLexicon = (lexicon_uuid) => {
    let name = this.props.lexicons[lexicon_uuid].name
    confirmAlert(
      {title: 'Delete Lexicon ' + name,
       message: 'Are you sure you want to delete this entire lexicon plus all its entries? This cannot be undone.',
       confirmLabel: 'Delete Entire Lexicon',
       cancelLabel: 'cancel',
       onConfirm: () => this.props.deleteLexicon(lexicon_uuid)
      }
    )
  }

  /*
   * Given a lexentry, run G2P on it, creating new lexentries.
   * Note: This will also delete the existing lexentry.
   */

  addG2P= (lex) => {
    const { language } = this.state;

    /* Run G2P on the graphemes */
    this.props.addG2P(lex.lexicon_uuid, lex.graphemes, lex.graphemes, language)

    /* Run G2P on the soundslike field */
    this.props.addG2P(lex.lexicon_uuid, lex.graphemes, lex.soundslike, language)

    /* Delete the existing entry */
    this.props.deleteLexentry(lex.lexicon_uuid, lex.lexentry_uuid)
  }

  setLanguage = (language) => {
    this.setState({
      language,
    });
  };

  /*
   * Helper functions
   */
  
  /*
   * Return a list of lexentry_uuids, where the lexentries associated
   * with those uuids are in sorted order (by graphemes, then
   * soundslike, then phonemes)
   */

  sortedLexentryUuids = () => {
    return Object.keys(this.props.lexentries).sort((k1,k2) => {
      var l1 = this.props.lexentries[k1]
      var l2 = this.props.lexentries[k2]
      if (l1.graphemes < l2.graphemes) {
	return -1
      }	
      if (l1.graphemes > l2.graphemes) {
	return 1
      }
      if (l1.soundslike < l2.soundslike) {
	return -1
      }
      if (l1.soundslike > l2.soundslike) {
	return 1
      }
      if (l1.phonemes < l2.phonemes) {
	return -1
      }
      if (l1.phonemes > l2.phonemes) {
	return 1
      }
      return 0
    })
  }

  /*
   * Play the given phonemes using the pronaudio endpoint. 
   */

  pronAudio = (phonemes) => {
    const { language } = this.state;
    if (! phonemes) {
      return
    }
    let audio = new Audio(this.props.rmi.lexicons.pronunciationAudio(phonemes.replace(/ /g, '_'), language))
    audio.play()
  }


  render() {
      return (
	<div>
	  <div>
      <LexiconControls
        lexicons={this.props.lexicons}
	    	currentLexicon={this.props.currentLexicon}
        language={this.state.language}
			  onSelectLexicon={this.props.getLexentries}
			  onDeleteLexicon={this.deleteLexicon}
	      onRenameLexicon={this.props.renameLexicon}
			  onAddLexicon={this.props.addLexicon}
			  onToggleShowAdvanced={this.toggleShowAdvanced}
        onSelectLanguage={this.setLanguage}
			  onAddLexicalEntry={this.addLexentry} />
	  </div>
	  <table>
	    <thead>
	      <tr>
		<th>Word</th>
		<th>Sounds Like</th>
		<th style={{width: '1px'}}>Action</th>		
		<th>Pronunciation</th>
		{this.state.showAdvanced && <th>Unigram</th>}
		{this.state.showAdvanced && <th>Prob</th>}
		{this.state.showAdvanced && <th>Silprob</th>}
	      </tr>
	    </thead>
	    <tbody>
	      { /* This sorts the lexentries on the fly. Maybe this should be a UI action instead? */
		this.sortedLexentryUuids().map(lexentry_uuid => {
		  return (
		    <LexentryRow key={lexentry_uuid}
				 lexentry={{...this.props.lexentries[lexentry_uuid],
					   lexentry_uuid: lexentry_uuid, lexicon_uuid: this.props.currentLexicon}}
				 showAdvanced={this.state.showAdvanced}
 				 onDelete={(lex) => this.props.deleteLexentry(lex.lexicon_uuid, lex.lexentry_uuid)}
				 onAddG2P={this.addG2P}
				 onPronAudio={(lex) => this.pronAudio(lex.phonemes)}
		                 updateField={(lex, field, value, sendToApi) => {
				     this.props.updateField(lex.lexicon_uuid, lex.lexentry_uuid, field, value, sendToApi)
				 }}
		    />
		  )})
	      }
	    </tbody>
	  </table>
	</div>
      )
    }
}  /* End class Lexicon */

/***********************************************************************
 *
 * Redux lifecycle stuff.
 *
 */

const mapStateToProps = state => ({
  lexentries: state.customizelexicon.lexentries,
  lexicons: state.customizelexicon.lexicons,
  currentLexicon: state.customizelexicon.currentLexicon,
  rmi: state.rmi
})

const mapDispatchToProps = dispatch => bindActionCreators({
  addG2P,
  addLexentry,
  addLexicon,
  deleteLexicon,
  renameLexicon,
  deleteLexentry,
  getLexicons,
  getLexentries,
  updateField,
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Lexicon)
